<template>
  <el-footer style="float: left;width: 100%;">
    <div style=" background-color: #EEEEEE;height: 90px; margin-top: 10px;text-align: center">
      <div style="padding-top: 15px; height:15px;font-size:14px;font-family:FangSong;
                  font-weight:bold;color:rgba(51,51,51,1);line-height:17px;">
        版权所有：济南市历城区精神卫生防治中心
      </div>
      <div style="padding-top: 10px; height:15px;font-size:14px;font-family:FangSong;
                  font-weight:bold;color:rgba(51,51,51,1);line-height:17px;">
        ICP备案：<a href="https://beian.miit.gov.cn" target="_blank">鲁ICP备2025165089号-1</a>
      </div><div style="padding-top: 10px; height:15px;font-size:14px;font-family:FangSong;
                  font-weight:bold;color:rgba(51,51,51,1);line-height:17px;">
      ©{{year}} www.lcjfzx.cn All Rights Reserved
      </div>
      <!--<div style="padding-top: 10px; height:15px;font-size:14px;font-family:FangSong;
                  font-weight:bold;color:rgba(51,51,51,1);line-height:17px;">
        医院热线电话: 0531-82818064
      </div>
      <div style="padding-top: 10px; height:15px;font-size:14px;font-family:FangSong;
                  font-weight:bold;color:rgba(51,51,51,1);line-height:17px;">
        地址: 济南市南部山区锦绣川车川村79号
      </div>
      <div style="padding-top: 10px; height:15px;font-size:14px;font-family:FangSong;
                  font-weight:bold;color:rgba(51,51,51,1);line-height:17px;">
        乘车路线：65路公交车直达
      </div>-->
    </div>
  </el-footer>
</template>

<script>
  export default {
    name: "footView",
    data() {
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/headerView/footView.vue